import React from 'react';
import { Card, Grid } from 'semantic-ui-react';
import _ from 'lodash';

import EventsFeed from '../../containers/event-feed';
import { FEED_TYPES } from '../../containers/event-feed/static';
import CampaignEmailSettings from '../../containers/campaign-email-settings';

const isEmailRecipient = member => _.includes(['TEAM_MEMBER', 'CAMPAIGN_OWNER'], member.role);

const CampaignNotificationsTab = ({ campaignId, campaignJSON }) => {
  const teamMembers = _.filter(campaignJSON.members, member => isEmailRecipient(member));
  return (
    <div style={{ margin: 30 }}>
      <Grid fluid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Card color="green" fluid>
              <Card.Content>
                <div>
                  <div>
                    <h2>Email Settings</h2>
                    <p style={{ color: 'rgba(0,0,0,.4)' }}>
                    manage the automated campaign summary emails.
                    </p>
                  </div>
                </div>
                <Card fluid>
                  <Card.Content>
                    <CampaignEmailSettings campaignId={campaignId} teamMembers={teamMembers} />
                  </Card.Content>
                </Card>
              </Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column width={8}>
            <EventsFeed
              cardColour="pink"
              campaignId={campaignId}
              feedType={FEED_TYPES.CAMPAIGN}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default CampaignNotificationsTab;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-notifications-tab/index.js
 **/